/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "find-depot",
	data() {
		return {
			map:{
				center: {lat: -30.204391819350786, lng: 26.262176705104167},
				zoom: 7,
				locations: [],
				openedMarkerId: null
			},
			depots: [],
			depotHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "City",
					field: "city"
				},
				{
					text: "Province",
					field: "province"
				},
				{
					text: "GPS Coordinates",
					field: "gpsCoordinates"
				},
				{
					text: "PhoneNumber",
					field: "primaryTelephoneNumber"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			provinces: [],
			provincesFilter: [],
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				provinceId: 0
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepots() {
			this.loading = true;
			this.map.locations = [];
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: true,
				provinceId: this.filter.provinceId === null ? 0 : this.filter.provinceId
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = dataTableHelper.castFieldValues(this.depots);
						this.filterStateChanged = false;
						for(var i = 0; i < this.depots.length; i++){
							var depot = this.depots[i];
							var coordinates = depot.gpsCoordinates.split(",");
							var location = {
								id: depot.depotId,
								position:{
									lat: parseFloat(coordinates[0]),
									lng: parseFloat(coordinates[1])
								},
								title: depot.name,
								phoneNumber: depot.primaryTelephoneNumber,
								email: depot.primaryEmailAddress,
								street: depot.street,
								suburb: depot.suburb,
								city: depot.city,
								province: depot.province,
								gpsCoordinates: depot.gpsCoordinates
							};
							this.map.locations.push(location);
						}
						console.log("map", this.map);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProvinces() {
			systemService.getProvinces().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.provinces = successResponse.data.result;
						this.provincesFilter = this.provinces;
						this.provinces = $.map(this.provinces,
							function (obj) {
								obj.id = obj.id || obj.provinceId;
								obj.text = obj.text || obj.description;
								return obj;
							});

						this.provincesFilter.unshift(
							{
								provinceId: 0,
								description: "All",
								countryId: 1
							});
						this.provincesFilter = $.map(this.provincesFilter,
							function (obj) {
								obj.id = obj.id || obj.provinceId;
								obj.text = obj.text || obj.description;
								return obj;
							}
						);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getDepots();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onProvinceFilterSelected(province){
			this.filter.provinceId = province.id;
			console.log("filter", this.filter);
		},
		openMapMarkInfoWindow(markerId) {
			this.map.openedMarkerId = markerId;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Find Depots");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Find Depots");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getDepots();
		this.getProvinces();
		this.$refs.mapRef.$mapPromise.then((mapObject) => {
			console.log('map is loaded now', mapObject);
		});
	}
};